import React, { useEffect } from "react";
import { INcParams } from "components/BecomePartnerModal/api";
import { setCaptcha } from "utils/captcha";

interface IProps {
  value?: INcParams;
  onChange?: (value: INcParams) => void;
}

/**
 * 人机校验
 */
export const NcCaptcha: React.SFC<IProps> = props => {
  const { onChange } = props;

  useEffect(() => {
    setCaptcha((ncParams: INcParams) => {
      onChange && onChange(ncParams);
    });
  }, []);
  return <div id="ali-captcha" />;
};
